import { AdobeEvent, AnalyticsAdapter } from './typing'

const analytics = (baseAction: (e: AdobeEvent) => void): AnalyticsAdapter => ({
  trackPage: (page, user, destinationUrl, campaign) => {
    const event: any = {
      event: 'page track',
      page: {
        ...page,
        destinationUrl,
        campaign,
      },
      user,
    }
    baseAction(event)
  },

  trackLink: (link, user) => {
    baseAction({
      event: 'link track',
      link,
      user,
    })
  },

  trackForm: (event, form, user) => {
    baseAction({
      event,
      form,
      user,
    })
  },

  trackIntent: (intent, user) => {
    // Emit the intent as a top-level Adobe event name and include
    // all required variables as top-level properties so analytics
    // tools can filter on event name + variables (per POC spec).
    // This ensures the top-level `event` is one of the approved
    // intent names (e.g., 'survey_selected') and the payload
    // contains interaction_type, element_type, page_name, element_name,
    // product, specialty, and user_type.
    const {
      event_name,
      interaction_type,
      element_type,
      page_name,
      element_name,
      product,
      specialty,
      user_type,
    } = intent as any

    baseAction({
      // event must be the approved intent event name (lowercase, underscore)
      event: event_name,
      // required variables must be present on every event
      interaction_type,
      element_type,
      page_name,
      element_name,
      product,
      specialty,
      user_type,
      // include a restricted user object if provided (avoid PII)
      user,
    })
  },
})

export default analytics
